import React from 'react';
import styles from './landingFaq.module.css';

interface LandingCopyrightProps {
  text: string;
}

const LandingCopyright: React.FC<LandingCopyrightProps> = ({ text }) => (
  <footer className={styles.copyright}>
    <p className={styles.copyrightText}>{text}</p>
  </footer>
);

export default LandingCopyright;
